import { useContext } from 'react';

// Components
import { RichText } from '@/components/RichText/RichText';
import { Context } from '@/components/Store';
import { languageStrings } from '@/l18n/de';
// Modules
import { isSupporter } from '@/lib/util';

const More = () => {
	const [state] = useContext(Context);

	const supporter = isSupporter(state.bundle);
	const contactEmail = supporter ? 'meinbeitrag@derStandard.at' : 'digitalabo@derStandard.at';

	return state?.bundle ? (
		<section className="product-more">
			<h3>{languageStrings.more.header}</h3>
			<p>
				<RichText
					components={{
						'email-link': <a href={`mailto:${contactEmail}`} />,
						'faq-link': (
							<a
								href="https://abo.derstandard.at/fragen-antworten"
								rel="noopener noreferrer"
								target="_blank"
							/>
						)
					}}
					message={languageStrings.more.productQuestions(contactEmail)}
				/>
			</p>

			{!supporter ? (
				<>
					<h3>{languageStrings.more.benefits}</h3>
					<p>
						<RichText
							components={{
								link: (
									<a
										href="https://abo.derstandard.at/abovorteile/"
										rel="noopener noreferrer"
										target="_blank"
									/>
								)
							}}
							message={languageStrings.more.goToOffers}
						/>
					</p>
				</>
			) : null}
		</section>
	) : null;
};

export { More };
